const isCreditCardNumberValid = (number: string): boolean => {
  if (number.length < 13 || number.length > 19) return false;

  let suma = 0;

  let ultimoDigito = number.substr(number.length - 1);

  number
    .substr(0, number.length - 1)
    .split("")
    .reverse()
    .forEach((stringDigit, index) => {
      let posicionImpar = (index + 1) % 2 !== 0;
      let digit = parseInt(stringDigit);
      suma += !posicionImpar
        ? digit
        : digit * 2 < 10
          ? digit * 2
          : digit * 2 - 9;
      return suma;
    });

  let digitoVerificador = 10 - ((suma % 10) % 10);

  if (digitoVerificador === 10) digitoVerificador = 0;

  let esNumeroValido = parseInt(ultimoDigito) === digitoVerificador;

  return esNumeroValido;
};

// Recibe el número tal como está en el formulario, que arranca en `null`.
const getCreditCardType = (accountNumber: string | null): string | null => {
  const number = String(accountNumber);

  if (/^5[1-5]/.test(number)) return "MasterCard";
  if (/^4/.test(number)) return "Visa";
  if (/^3[47]/.test(number)) return "AmericanExpress";
  if (/^36/.test(number)) return "Diners";

  return null;
};

export { isCreditCardNumberValid, getCreditCardType };
